import React, { useEffect, useMemo } from "react";
import { Button, ErrorBlock } from '@hose/eui';
import { ToolComponentCtx } from '@hose/chat-app';
import { useExpenseLinkSelection } from "../../hooks/useChatInitialization";
import { openBillStackerModal } from '../../utils/postmate'
import RelatedItem, { RelatedItemProps } from './RelatedItem'
import { useMatchedData } from '../../hooks/useMatchedData'
import './index.less'
import { getParamFromUrl } from "../../utils/tools";

export const RelatedApplication: React.FC<ToolComponentCtx> = (props) => {
  const { state, toolCallId } = props
  // 获取父应用传递的关联申请数据
  const expenseLinks = useExpenseLinkSelection();

  const isMobile = useMemo(() => {
    return getParamFromUrl('platform') === 'mobile'
  }, [])    

  // 复用通用 Hook：数据解析、倒计时、隐藏与缓存
  const {
    matchedData,
    setMatchedData,
    onConfirm,
    isHidden,
    countdown,
    isCountdown,
    cancelCountdown
  } = useMatchedData<RelatedItemProps>(props, {
    defaultData: [],
    enableAutoSubmit: true,
    countdownSeconds: 10,
    hideAfterSubmit: true,
    enableCache: true,
    parseData: (result: any) => Array.isArray(result) ? result : []
  })
  
  // 外部选择替换当前列表并取消倒计时
  useEffect(() => {
    if (expenseLinks && expenseLinks?.toolCallId === toolCallId) {
      setMatchedData(expenseLinks?.selectedData)
    }
  }, [expenseLinks, setMatchedData, toolCallId])

  // 删除申请项
  const handleDelete = (code: string) => {
    cancelCountdown()
    setMatchedData(prev => prev.filter(item => item.code !== code))
  }

  // 清空选择
  const handleClearAll = () => {
    cancelCountdown()
    setMatchedData([])
  }

  const handleAddExpenseLink = async () => {
    try {
      cancelCountdown()
      // 使用工具函数打开选择关联申请的弹框
      await openBillStackerModal({
        toolCallId,
        dataSource:matchedData
      });
    } catch (error) {
      console.error("❌ 发送过程中出现异常:", error);
      alert("发送过程中出现错误，请重试");
    }
  }

  if (state !== 'result' || isHidden) {
    return null
  }

  if (state === 'result' && !props?.result) {
    return null
  }

  return <div className="related-application-result-container" data-testid="related-application-result-container">
    <header className="header">请确认您本次报销是否与以下事项相关</header>
    {
      matchedData.length > 0 ? matchedData.map(item => (
        <RelatedItem
          key={item.id}
          {...item}
          className="content"
          onDelete={handleDelete}
        />
      )) : <ErrorBlock status="empty" title="暂无内容" className="w-full" />
    }
    <div className="actions">
      <div className="left action-item">
        <Button category="text"  size={isMobile ? 'small' : 'middle'} theme="highlight" disabled={matchedData.length === 0} onClick={handleClearAll}>清空选择</Button>
        <Button category="text" size={isMobile ? 'small' : 'middle'} theme="highlight" onClick={handleAddExpenseLink}>关联申请</Button>
      </div>
      <div className="right action-item">
        <Button
          category="primary"
          theme="highlight"
          onClick={onConfirm}
          size={isMobile ? 'small' : 'middle'}
        >
          {isCountdown ? `确认(${countdown}s)` : '确认'}
        </Button>
      </div>
    </div>
  </div>
}

export default RelatedApplication